import { AJOUTE_RESTAURANT,SUPRIMER_RESTAURANT } from '../types/typeRestaurant';

export const AjouteRestaurant = (restaurant) => {
    return {
        type: AJOUTE_RESTAURANT,
        payload: restaurant
    }
}

export const suprimerRestaurant = (restaurant) => {
    return {
        type: SUPRIMER_RESTAURANT,
        payload:restaurant
    }
}